import React, { useEffect, useState } from 'react';
import { SkeletonBox } from '../../components/Product/Skeleton/styled';
import { PriceDetailNew } from '../../components/CategoryDetail/L1CategoryPage/ProductCardNew/styled';
import { getWebUserType } from '../getWebUserType';

function ProductPriceAB(props) {
  const {
    priceData,
    classString,
    classStringStrike,
    classStringDisc,
    singleProduct,
    noGap,
    paddingTop,
    isAllCategoryPage,
  } = props;

  const [loadOnClient, setLoadOnClient] = useState(false);
  const calculateDiscout = (price) => {
    let newPrice = price;
    let newStrikePrice = priceData?.strikePrice;
    if (price?.includes('₹')) {
      newPrice = price.split('₹')?.[1];
    }
    if (priceData?.strikePrice.includes('₹')) {
      newStrikePrice = priceData?.strikePrice.split('₹')?.[1];
    }
    if (newStrikePrice) {
      let discountPercent = Math.ceil(
        ((newStrikePrice - newPrice) / newStrikePrice) * 100,
      );
      return `${discountPercent}% Off`;
    }
  };
  useEffect(() => {
    setLoadOnClient(true);
  }, []);
  return loadOnClient ? (
    <PriceDetailNew
      paddingTop={paddingTop}
      noGap={noGap}
      singleProduct={singleProduct}
      isAllCategoryPage={isAllCategoryPage}
    >
      {getWebUserType() == 'A' ? (
        <>
          <p className={classString}>{priceData?.priceA}</p>
          {priceData?.priceA !== priceData?.strikePrice ? (
            <>
              <p className={classStringStrike}>{priceData?.strikePrice}</p>
              <p className={classStringDisc}>
                {calculateDiscout(priceData?.priceA)}
              </p>
            </>
          ) : null}
        </>
      ) : (
        <>
          <p className={classString}>{priceData?.priceB}</p>
          {priceData?.priceB !== priceData?.strikePrice ? (
            <>
              <p className={classStringStrike}>{priceData?.strikePrice}</p>
              <p className={classStringDisc}>
                {calculateDiscout(priceData?.priceB)}
              </p>
            </>
          ) : null}
        </>
      )}
    </PriceDetailNew>
  ) : (
    <SkeletonBox height="30px" width="170px" />
  );
}

export default ProductPriceAB;
